export default function adminCleanPhone(phone: string) {
  return phone.slice(4).slice(0, 4) + ' ' + phone.slice(4).slice(4)
}
